import jQuery from 'jquery';
import Forms from './Forms';
import RichText from './RichText';
export default class StaticArticle {
    constructor(section) {
        this.$el = jQuery(section.el);
        this.$commentForm = this.$el.find('[data-articlecomments-form]');
        this.richText = new RichText(this.$el);
        if (this.$commentForm.length) {
            this.commentForm = new Forms(this.$commentForm);
        }
    }
    onSectionUnload() {
        this.richText.unload();
        if (this.commentForm) {
            this.commentForm.unload();
        }
    }
}
